import type { Firestore } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Narrow the lazily-initialised Firestore handle to a non-null value.
 *
 * `db` starts as null and is assigned in initializeFirebase(), so every repo module needs this
 * guard before touching Firestore. Until now each of the 22 repo modules carried its own
 * byte-identical copy (modulo brace style); this is that copy, extracted verbatim.
 *
 * Note: src/lib/firebase.ts also exports getDbSafe(), which is nearly identical but throws
 * "Firestore is not initialized." — a different message. The two are deliberately kept separate
 * so this extraction changes no observable behaviour.
 */
export function ensureDb(): Firestore {
  if (!db) throw new Error('Firestore not initialized');
  return db;
}
